﻿

(() => {
    angular.module('fliptoWeb')
        .controller('ContactCtrl', ['$scope', '$window', 'ApiService', '$analytics',
        function ($scope, $window, ApiService, $analytics) {
            "use strict";

            var vm = this;

            // TO DO: Need to have dev dynamically generate analytics-label based on where intial click came from. Either from "about contact us", "footer contact us", "blog article contact us", "news article contact us", or "subscription error contact us" //
            var trackingInfo = {
                submitForm: {
                    eventName: "submitted contact us form",
                    eventProperties: {
                        category: "contacts",
                        label: "about contact us"
                    }
                },
                submitSuccess: {
                    eventName: "successful contact us form submit",
                    eventProperties: {
                        category: "contacts",
                        label: "about contact us"
                    }
                },
                submitFail: {
                    eventName: "failed contact us form submit",
                    eventProperties: {
                        category: "contacts",
                        label: "about contact us"
                    }
                },
                modalAbandon: {
                    submitted: "closed modal after contact us form submit",
                    abandon: "hard abandoned contact us"
                }
            }

            vm.firstName = "";
            vm.lastName = "";
            vm.email = "";
            vm.notes = "";

            vm.activeSection = 0;

            vm.activateSection = section => {
                this.activeSection = section;
            }

            vm.errorMessage = "";

            vm.processingRequest = false;

            vm.hasBeenSubmitted = false;

            vm.trackingInfo = () => {
                return vm.hasBeenSubmitted ? trackingInfo.modalAbandon.submitted : trackingInfo.modalAbandon.abandon;
            }

            vm.submit = () => {
                this.errorMessage = "";
                this.processingRequest = true;

                $analytics.eventTrack(trackingInfo.submitForm.eventName, trackingInfo.submitForm.eventProperties);

                var data = {
                    First: this.firstName,
                    Last: this.lastName,
                    Email: this.email,
                    Description: this.notes
                }

                //todo: turn this into a utility service and call it from all contact forms
                var analyticsData = ((obj) => {
                    var dataObj = {};
                    for (var i in obj) {
                        if (obj.hasOwnProperty(i) && i !== "ExtendedData") {
                            dataObj[i] = data[i];
                        } else if (obj.hasOwnProperty(i) && i === "ExtendedData") {
                            angular.forEach(obj[i], item => {
                                dataObj[item.Key] = item.Value;
                            });
                        }
                    }
                    return dataObj;
                })(data);

                $analytics.setUsername(data.Email || data.First + ' ' + data.Last);
                $analytics.setUserProperties(analyticsData);

                ApiService.ContactUs_Post(data)
                    .then(function (response) {
                        if (response.data.Success) {
                            vm.activateSection(1);
                            vm.hasBeenSubmitted = true;
                            $analytics.eventTrack(trackingInfo.submitSuccess.eventName, trackingInfo.submitSuccess.eventProperties);
                        } else {
                            vm.errorMessage = response.data.Message;
                            $analytics.eventTrack(trackingInfo.submitFail.eventName, trackingInfo.submitFail.eventProperties);
                        }

                        vm.processingRequest = false;
                    });
            }

    }]);
})()
